import { z } from "zod";
import { LinkedButtonWhenEnumSchema } from "../Enums/LinkedButtonWhenEnum";

export const LinkedOdvetvieIdDtoSchema = z.object({
    linkedOdvetvieId: z.number(),
    linkedOdvetvieWhen: LinkedButtonWhenEnumSchema.nullish(),
});

export type LinkedOdvetvieIdDto = z.infer<typeof LinkedOdvetvieIdDtoSchema>;